<template>
    <svg ref="blobContainer" :class="styles" viewBox="0 0 1000 1000">
        <path class="fill-current" ref="blob"></path>
    </svg>
</template>

<script>
export default {
    props: {
        styles: String
    },

    data() {
        return {
            blob: null,
            points: [],
            numPoints: 16,
            centerX: 500,
            centerY: 500,
            minRadius: 400,
            maxRadius: 455,
            minDuration: 1,
            maxDuration: 2,
            tl: null
        };
    },

    computed: {
        slice() {
            return (Math.PI * 2) / this.numPoints;
        }
    },

    mounted() {
        this.blob = this.$refs.blob;
        const startAngle = this.randomizer(Math.PI * 2);

        const tl = greensock.timeline({
            onUpdate: this.update,
            paused: false
        });

        for (let i = 0; i < this.numPoints; i++) {
            const angle = startAngle + i * this.slice;
            const duration = this.randomizer(this.minDuration, this.maxDuration);

            const point = {
                x: this.centerX + Math.cos(angle) * this.minRadius,
                y: this.centerY + Math.sin(angle) * this.minRadius
            };

            const tween = greensock.to(point, {
                x: this.centerX + Math.cos(angle) * this.maxRadius,
                y: this.centerY + Math.sin(angle) * this.maxRadius,
                duration: duration,
                repeat: -1,
                yoyo: true,
                ease: 'sine.inOut'
            });

            tl.add(tween, -this.randomizer(duration));
            this.points.push(point);
        }

        tl.progress(1)
            .progress(0)
            .timeScale(0);
        this.update();

        greensock.to(tl, {
            timeScale: 1,
            duration: 0.3,
            onStart() {
                tl.play();
            }
        });

        this.tl = tl;
    },

    methods: {
        update() {
            this.blob.setAttribute('d', this.cardinal(this.points, true, 1));
        },

        cardinal(data, closed, tension) {
            if (data.length < 1) return 'M0 0';
            if (tension == null) tension = 1;

            let size = data.length - (closed ? 0 : 1);
            let path = `M${data[0].x} ${data[0].y} C`;

            for (let i = 0; i < size; i++) {
                let p0;
                let p1;
                let p2;
                let p3;

                if (closed) {
                    p0 = data[(i - 1 + size) % size];
                    p1 = data[i];
                    p2 = data[(i + 1) % size];
                    p3 = data[(i + 2) % size];
                } else {
                    p0 = i == 0 ? data[0] : data[i - 1];
                    p1 = data[i];
                    p2 = data[i + 1];
                    p3 = i == size - 1 ? p2 : data[i + 2];
                }

                let x1 = p1.x + ((p2.x - p0.x) / 6) * tension;
                let y1 = p1.y + ((p2.y - p0.y) / 6) * tension;

                let x2 = p2.x - ((p3.x - p1.x) / 6) * tension;
                let y2 = p2.y - ((p3.y - p1.y) / 6) * tension;

                path += ` ${x1} ${y1} ${x2} ${y2} ${p2.x} ${p2.y}`;
            }

            return closed ? `${path}z` : path;
        },

        randomizer(min, max) {
            if (max == null) {
                max = min;
                min = 0;
            }
            if (min > max) {
                var tmp = min;
                min = max;
                max = tmp;
            }
            return min + (max - min) * Math.random();
        },

        pause() {
            this.tl.pause();
        }
    }
};
</script>
